export default function Projects() {
  const projects = [
    { 
      title: "Personal Portfolio", 
      desc: "A modern, responsive portfolio website showcasing my skills and projects. Features smooth animations, clean design, and optimized performance.", 
      tech: ["React", "Tailwind CSS", "JavaScript", "CSS3"],
      link: "#home",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      )
    },
    { 
      title: "Vimarsha", 
      desc: "An intelligent AI platform that analyzes presentations and provides detailed feedback on content, structure, and delivery to improve presentation skills.", 
      tech: ["Html", "Css", "JavaScript", "Flask", "Machine Learning", "Sqlite"],
      link: "#",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
        </svg>
      )
    },
    { 
      title: "Interactive Calculator", 
      desc: "A fully functional calculator application with a clean, modern interface. Features basic arithmetic operations, responsive design, and smooth animations.", 
      tech: ["HTML5", "CSS3", "JavaScript", "Responsive Design"],
      link: "#",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2zm4 8h-2v-6h2v6zm0-8h-2V7h2v2z"/>
        </svg>
      )
    },
  ];

  return (
    <section id="projects" className="py-20 bg-emerald-light text-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-bold text-emerald-600 mb-4">
            Featured Projects
          </h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-2xl mx-auto">
            Showcasing my passion for creating innovative digital solutions
          </p>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mt-6 rounded-full"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {projects.map((p, i) => (
            <div key={i} className={`group bg-gradient-to-br from-purple-800/30 to-pink-800/30 backdrop-blur-sm rounded-2xl p-8 hover:from-purple-700/40 hover:to-pink-700/40 transition-all duration-500 hover:-translate-y-4 border border-cyan-500/20 hover:border-cyan-400/40 animate-slide-up delay-${(i + 1) * 100} hover:scale-105`}>
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center text-white mb-0 mr-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                  {p.icon}
                </div>
                <h3 className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors">{p.title}</h3>
              </div>
              <p className="text-purple-100 leading-relaxed mb-6">{p.desc}</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {p.tech.map((tech, idx) => (
                  <span key={idx} className="px-3 py-1 bg-cyan-500/20 text-cyan-300 rounded-full text-sm backdrop-blur-sm hover:bg-cyan-500/30 transition-colors">
                    {tech}
                  </span>
                ))}
              </div>
              <a href={p.link} className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 font-semibold transition-all duration-300 group/link">
                View Project 
                <svg className="w-4 h-4 group-hover/link:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
